import * as React from "react";
import {useContext} from "react";
import {useNavigate} from "react-router-dom";
import LockOutlineIcon from "@mui/icons-material/LockOutline";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import {Button, Typography} from "@mui/material";

import css from "../css/locker.module.css";
import {MiniAppContext} from "../pages/MiniApp";

export const Locker = ({top, left, children}) => {
    const {locked} = useContext(MiniAppContext)
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);

    return !locked ? children : (
        <div onClick={e => e.stopPropagation()}>
            <div className={css.locker} onClick={() => setOpen(true)}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <LockOutlineIcon className={css.icon} style={{top, left}}/>
                    <div style={{marginLeft: 9}}>
                        {children}
                    </div>
                </div>
            </div>
            <Dialog onClose={() => setOpen(false)} open={open}>
                <DialogTitle sx={{m: 0, p: 2}}>Функция заблокирована</DialogTitle>
                <IconButton title={"Закрыть"} onClick={() => setOpen(false)} sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}><CloseIcon/></IconButton>
                <DialogContent dividers>
                    <Typography variant={"h5"} align={"center"}>
                        <LockOutlineIcon sx={{fontSize: 40}}/>
                    </Typography>
                    <Typography variant={"h5"} align={"center"}>
                        Эта функция доступна
                    </Typography>
                    <Typography variant={"h5"} align={"center"} gutterBottom>
                        в тарифах "Премиум" и выше
                    </Typography>
                    <Button id={"chooseTariff"} sx={{mt: 1}} fullWidth={true} variant={"contained"} autoFocus
                            onClick={() => {
                                navigate("/payment");
                                setOpen(false);
                            }}>Выбрать тариф</Button>
                </DialogContent>

            </Dialog>
        </div>
    )
}
